import { Page } from '@/core/architecture'

import { LotteryApplicationDetailCancelCompletionTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * LotteryApplicationDetailCancelCompletion Page
 * Implemented as a practical sample.
 */
export const LotteryApplicationDetailCancelCompletion: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <LotteryApplicationDetailCancelCompletionTemplate
      state={state}
      {...actions}
    />
  )
}
